import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete, Visibility, Download, Store } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";

function List(props) {
  let vendorType = "";
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";
  const [godownList, setGodownList] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: "Godown Name",
      selector: (row) => row.godown_name,
    },
    {
      name: "Name",
      selector: (row) => row.contact_person_name,
    },

    {
      name: "state",
      selector: (row) => row.godown_state,
    },
    {
      name: "city",
      selector: (row) => row.godown_city,
    },

    {
      name: "View",
      cell: (row) => (
        <>
          <RB.Button
            className="btn-circle"
            variant="outline-primary"
            size="sm"
            onClick={handleView(row)}
          >
            <Visibility />
          </RB.Button>
        </>
      ),
      center: true,
    },

    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <RB.Button
            className="btn-circle"
            variant="outline-primary"
            size="sm"
            onClick={handelEdit(row)}
          >
            <EditIcon />
          </RB.Button>
          &nbsp;
          <RB.Button
            className="btn-circle"
            variant="outline-danger"
            size="sm"
            onClick={showDelete(row)}
          >
            <Delete />
          </RB.Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    getGodownList();
  }, [page, userProfile?.id, vendorType]);

  const getGodownList = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("dealership_id", props?.id);
    bodyFormData.append("id", "");
    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI("post", `/sales/getgodownList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setGodownList(res);
        } else {
          setGodownList([]);
        }
      })
      .catch((err) => {
        setGodownList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleGodown = useCallback((row) => async () => {
    const propdata = {
      mode: "godown",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/DeleteGodown?id=${row.id}`)
          .then((res) => {
            if (typeof res !== "undefined") {
              getGodownList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props?.row?.onChange(propdata);
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4>Godown List</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
            {/* {utils.hasPermission(primaryMenuRes, "Quotation", "quotation.create") && ( */}
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleAddClick}
            >
              Add Godown
            </RB.Button>
            {/* )} */}
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <DataTable
            columns={columns}
            data={godownList.result}
            highlightOnHover
            responsive
            pagination
            paginationServer
            paginationTotalRows={godownList.total}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            striped
            onChangePage={(page) => setPage(page)}
            persistTableHead
            customStyles={{
              head: {
                style: {
                  fontSize: "0.875rem", // Adjust the font size as needed
                  fontWeight: "bold", // Adjust the font weight as needed
                },
              },
            }}
            // subHeader
            // subHeaderComponent={subHeaderComponent}
          />
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
